module.exports = __webpack_public_path__ + "static/media/dsv1.c2f8e345.PNG";